import { render } from "./ArrowDropdown.vue?vue&type=template&id=451c8946"
const script = {}
script.render = render

export default script